export enum PlayerStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

// Always returns a number, even if a BigInt is passed in
export function normalizeTimestamp(timestamp: number | bigint): number {
  return typeof timestamp === 'bigint' ? Number(timestamp) : timestamp as number
}

export function formatTimestamp(timestamp: number | bigint): string {
  const ts = normalizeTimestamp(timestamp)
  return ts
    ? `${new Date(ts).toLocaleDateString('en-US')}, ${new Date(ts).toLocaleTimeString('en-US')}`
    : 'No timestamp submitted.'
}

export function getStatus(timestamp: number | bigint, duration: number): PlayerStatus {
  const ts = normalizeTimestamp(timestamp)
  if (!ts) return PlayerStatus.WARNING
  if ((Date.now() - ts) > 3 * duration) return PlayerStatus.CRITICAL
  return PlayerStatus.OK
}

export function convertMS(ms: number): string {
  let h: number; let m: number; let s: number
  s = Math.floor(ms / 1000)
  m = Math.floor(s / 60)
  s %= 60
  h = Math.floor(m / 60)
  m %= 60
  const d = Math.floor(h / 24)
  h %= 24
  h += d * 24
  return `${h.toString().padStart(2, '0')}hr : ${m.toString().padStart(2, '0')}min : ${s.toString().padStart(2, '0')}.${(ms % 1000).toString().padStart(3, '0')}s`
}

